import { render, staticRenderFns } from "./ChecklistMentor.vue?vue&type=template&id=c54ff792&scoped=true&"
import script from "./ChecklistMentor.vue?vue&type=script&lang=js&"
export * from "./ChecklistMentor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c54ff792",
  null
  
)

export default component.exports